// Copyright (c) 2018 Comsearch, Inc., All rights reserved

export const CANNOT_BE_IN_THE_FUTURE = 'Cannot be in the future.'
export const CANNOT_BE_IN_THE_PAST = 'Cannot be in the past.'
export const INVALID_DATE = 'Invalid Date'
export const INVALID_DATE_FORMAT = 'Invalid date format: YYYY/MM/DD'
export const CANNOT_BE_MORE_THAN_35_DAYS = 'Cannot be more than 35 days in the future.'
